"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var XlsDownload = function XlsDownload(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.29,18,18,19.29V14.5a.5.5,0,1,0-1,0v4.79L15.71,18a.5.5,0,1,0-.71.71l2.15,2.15a.5.5,0,0,0,.71,0L20,18.71a.5.5,0,1,0-.71-.71Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11 1 11 6 16 6 11 1",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,11A6.5,6.5,0,1,0,24,17.5,6.5,6.5,0,0,0,17.5,11ZM20,18.71l-2.15,2.15a.5.5,0,0,1-.71,0L15,18.71a.5.5,0,1,1,.71-.71L17,19.29V14.5a.5.5,0,1,1,1,0v4.79L19.29,18a.5.5,0,1,1,.71.71Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.85,5.15l-5-5A.5.5,0,0,0,11.5,0H.5A.5.5,0,0,0,0,.5v21a.5.5,0,0,0,.5.5h11A7.48,7.48,0,0,1,17,10V5.5A.5.5,0,0,0,16.85,5.15ZM5.64,11.59,4.66,10l-1,1.61H3l1.3-2L3.06,7.67h.71l.91,1.49.91-1.49h.69L5.06,9.57l1.32,2Zm3.57,0H6.91V7.67h.64V11H9.21Zm2.56-.24a1.65,1.65,0,0,1-1,.3,2.49,2.49,0,0,1-1.09-.21v-.61a3,3,0,0,0,.57.2,2.41,2.41,0,0,0,.56.07.89.89,0,0,0,.56-.15.47.47,0,0,0,.18-.39.49.49,0,0,0-.17-.37,2.51,2.51,0,0,0-.69-.36,1.82,1.82,0,0,1-.76-.5,1.05,1.05,0,0,1-.22-.67A.94.94,0,0,1,10,7.89,1.45,1.45,0,0,1,11,7.61a2.75,2.75,0,0,1,1.12.25l-.2.52A2.45,2.45,0,0,0,11,8.16a.72.72,0,0,0-.47.14.44.44,0,0,0-.16.36.5.5,0,0,0,.06.26.65.65,0,0,0,.21.21,3.59,3.59,0,0,0,.53.26,2.91,2.91,0,0,1,.63.34,1,1,0,0,1,.3.35,1.06,1.06,0,0,1,.09.46A1,1,0,0,1,11.78,11.35ZM11,6V1l5,5Z"
  }));
};

var _default = XlsDownload;
exports["default"] = _default;